<form *ngIf="form && fields" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="form" (submit)="save()">
  <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">
    <div class="ui-g">

      <div class="ui-g-8 ui-md-8 ui-lg-8">
        <h1 class="step-title" *ngIf="!editMode">{{ 'card.add_title' | translate}}</h1>
        <h1 class="step-title" *ngIf="editMode && !isFromCustomerDetail">{{ 'card.edit_title' | translate}}</h1>
        <h1 class="step-title" *ngIf="editMode && isFromCustomerDetail">{{ 'card.detail_title' | translate}}</h1>
      </div>

      <div class="ui-g-4 ui-md-4 ui-lg-4 form-button-row">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" (click)="goBack()"
          label="{{ 'common.back' | translate }}"></button>
        <button pButton class="k-generic-btn" type="button" icon="fa fa-pencil" iconPos="left"
          routerLink="{{ '/loyalty/card/form/edit/' + cardId }}" label="Edit" *ngIf="canEdit()"></button>
        <button pButton class="k-generic-btn" type="submit" icon="fa fa-floppy-o" iconPos="left" label="Save"
          *ngIf="!readonly"></button>
      </div>

    </div>

    <div class="card">
      <div class="ui-g ui-fluid">

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.card_no.nullable}">{{ fields.card_no.keyName }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="card_no">
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form"
            [validation]="fields.card_no"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.channel_id.nullable}">{{ fields.channel_id.keyName
            }}</span>
          <p-dropdown [options]="channels" formControlName="channel_id"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form"
            [validation]="fields.channel_id"></app-validation-msg>

        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.store_id.nullable}">{{ fields.store_id.keyName }}</span>
          <p-dropdown [options]="stores" formControlName="store_id" [filter]="true"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form"
            [validation]="fields.store_id"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.card_type_pid.nullable}">{{ fields.card_type_pid.keyName
            }}</span>
          <p-dropdown [options]="params" formControlName="card_type_pid"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form"
            [validation]="fields.card_type_pid"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.card_batch_id.nullable}">{{ fields.card_batch_id.keyName
            }}</span>
          <p-dropdown [filter]="true" [options]="cardBatchs" formControlName="card_batch_id"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form"
            [validation]="fields.card_batch_id"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.card_def_id.nullable}">{{ fields.card_def_id.keyName
            }}</span>
          <p-dropdown [options]="cardDefinitions" formControlName="card_def_id"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form"
            [validation]="fields.card_def_id"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.date_start.nullable}">{{ fields.date_start.keyName
            }}</span>
          <app-kv-calendar #dateStartField [inputName]="'date_start'" [formData]="form" [startDateSelector]="true"
            [endDateInputName]="'date_end'" [endDateCalendar]="dateEndField" [defaultDate]="defaultStartDate"
            [defaultValue]="defaultStartDate" [disabled]="dateFieldsDisabled">
          </app-kv-calendar>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form"
            [validation]="fields.date_start"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4">
          <span class="label" [ngClass]="{'required': !fields.date_end.nullable}">{{ fields.date_end.keyName }}</span>
          <app-kv-calendar #dateEndField [inputName]="'date_end'" [formData]="form" [endDateSelector]="true"
            [startDateInputName]="'date_start'" [startDateCalendar]="dateStartField" [defaultDate]="defaultEndDate"
            [defaultValue]="defaultEndDate" [disabled]="dateFieldsDisabled">
          </app-kv-calendar>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form"
            [validation]="fields.date_end"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-4"></div>

      </div>
    </div>

    <!-- Link PDF -->
    <div class="card">
      <div class="ui-g ui-fluid">
        <div class="ui-g-12">
          <span class="label" [ngClass]="{'required': !fields.pdf_link.nullable}">{{ fields.pdf_link.keyName }}</span>
        </div>
        <div class="ui-g-12" id="pdf-link-input-container">
          <input #pdfLinkInput data-testid="pdfLinkInput" type="text" pInputText class="fieldInput"
            formControlName="pdf_link">
          <p-button label="{{'card.showPdf' | translate}}" [disabled]="!pdfBaseUrl || !pdfLinkInput.value"
            (onClick)="testPdfUrl(pdfLinkInput.value)"></p-button>
        </div>
      </div>
    </div>

    <!-- Blacklist -->
    <div class="ui-g">
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <h1 class="step-title">{{ 'card.blacklist_card_header' | translate }}</h1>
      </div>
    </div>

    <div class="card">
      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-2">
          <span class="label">{{ fields.flg_blk_lst.keyName }}</span>
          <p-inputSwitch #blacklist data-testid="blacklist" [disabled]="!cardEditBlacklistPermission"
            formControlName="flg_blk_lst" class="blacklist-switch" (onChange)="blacklistChange()"></p-inputSwitch>
        </div>

        <div class="ui-g-12 ui-md-4" [hidden]="!blacklist.checked">
          <span class="label" [ngClass]="{'required': !fields.reason_id.nullable}">{{ fields.reason_id.keyName }}</span>
          <p-dropdown [disabled]="!cardEditBlacklistPermission" [options]="reasons"
            formControlName="reason_id"></p-dropdown>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form"
            [validation]="fields.reason_id"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-3" [hidden]="!blacklist.checked">
          <span class="label" [ngClass]="{'required': !fields.date_blk_lst.nullable}">{{ fields.date_blk_lst.keyName
            }}</span>
          <p-calendar [disabled]="!cardEditBlacklistPermission" formControlName="date_blk_lst"
            dateFormat="dd/mm/yy"></p-calendar>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form"
            [validation]="fields.date_blk_lst"></app-validation-msg>
        </div>

        <div class="ui-g-12 ui-md-3" [hidden]="true">
          <span class="label" [ngClass]="{'required': !fields.time_blk_lst.nullable}">{{ fields.time_blk_lst.keyName
            }}</span>
          <p-calendar [disabled]="!cardEditBlacklistPermission" [timeOnly]="true" hourFormat="24"
            formControlName="time_blk_lst"></p-calendar>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="form"
            [validation]="fields.time_blk_lst"></app-validation-msg>
        </div>

      </div>
    </div>
  </div>
</form>


// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-card/form-card/form-card.component.html